import { useMemo } from 'react';
import { type SupportedIntegrationSyncTypes, useSourceBlockContext } from '#shared/lib/integrations';
import {
    useGetIntegrationSettingsOrders,
    useGetIntegrationSettingsPrices,
    useGetIntegrationSettingsProducts,
    useGetIntegrationSettingsStocks,
} from '../api';

const ENDPOINT_GET_INTEGRATION_SETTINGS = {
    products: useGetIntegrationSettingsProducts,
    stocks: useGetIntegrationSettingsStocks,
    orders: useGetIntegrationSettingsOrders,
    prices: useGetIntegrationSettingsPrices,
    mc_feed: useGetIntegrationSettingsProducts,
} satisfies Record<SupportedIntegrationSyncTypes, typeof useGetIntegrationSettingsProducts>;

export const useGetIntegrationSettings = () => {
    const { syncType } = useSourceBlockContext();

    const useEndpoint = useMemo(() => ENDPOINT_GET_INTEGRATION_SETTINGS[syncType], [syncType]);

    return useEndpoint();
};
